import calc from 'calculatorjs'
import { isVirtualGoods } from '@g/utils/tbdgUtils'

const SS_PREPARE_KEY = 'mgb:dgorder:prepareModel'
const SS_CATEGORY_PATHS_KEY = 'mgb:dgorder:categoryPathsModel'

const readSS = (key) => {
  try { return JSON.parse(sessionStorage.getItem(key) || 'null') } catch { return null }
}
const writeSS = (key, val) => {
  if (val == null) sessionStorage.removeItem(key)
  else sessionStorage.setItem(key, JSON.stringify(val))
}

const state = {
  prepareModel: readSS(SS_PREPARE_KEY),
  categoryPathsModel: readSS(SS_CATEGORY_PATHS_KEY),
  nearAddrid: '',
  form: {
    receiveAddrid: '',
    othderAddrid: '',
  },
  goodsInfo: null,
  buyNumMap: {},
  previewData: null,
  firstPropsValue: '',
  freight: 0, // 预估运费

  stepId1688: '',
  orderConfirmHtml: '',

  detailOrder: null,

  choseDgids: [],
  couponrelList: [],
  invoiceInfo: null,
  isDefaultInvoiceInfo: 0,

  flow: 'general', // general: 批發(現貨), fenxiao: 代發(分銷)
}

const converGoodsInfo = (goodsInfo) => {
  if (!Array.isArray(goodsInfo.tagInfoList)) {
    goodsInfo.tagInfoList = []
  }
  goodsInfo.isOnePsale = goodsInfo.tagInfoList.find(v => v.key === 'isOnePsale')?.value

  if (!goodsInfo.productSkuInfos?.length) {
    // https://detail.1688.com/offer/676740810309.html
    // 没有 SKU 的商品   660055603761 840253212
    goodsInfo.productSkuInfos = [{
      ...goodsInfo.productSaleInfo,
      priceRangeList: undefined,
      skuId: '',
      specId: '',
      skuAttributes: [
        {
          attributeId: 1234,
          attributeName: '采购量',
          attributeNameTrans: '',
          value: '',
          valueTrans: '',
          skuImageUrl: ''
        }
      ],
    }]
  }
  goodsInfo.hasPromoPrice = false
  goodsInfo.rawMinOrderQuantity = goodsInfo.minOrderQuantity
  if (!goodsInfo.sellerMixSetting) {
    const tag = goodsInfo.tagInfoList.find(v => v.key === 'isSupportMix')
    if (tag) {
      tag.value = false
    }
  }
  if (!goodsInfo.tagInfoList.find(v => v.key === 'isSupportMix')?.value) {
    // 不支持混批
    goodsInfo.sellerMixSetting = undefined
  }

  if (goodsInfo.sellerMixSetting?.mixNumber && goodsInfo.productSaleInfo.priceRangeList) {
    goodsInfo.minOrderQuantity = Math.min(goodsInfo.minOrderQuantity, goodsInfo.sellerMixSetting.mixNumber)
    if (goodsInfo.productSaleInfo.priceRangeList[0].startQuantity > goodsInfo.sellerMixSetting.mixNumber) {
      goodsInfo.productSaleInfo.priceRangeList.splice(0, 1, {
        ...goodsInfo.productSaleInfo.priceRangeList[0],
        startQuantity: goodsInfo.sellerMixSetting.mixNumber,
      })
    }
  }
  return goodsInfo
}
// https://open.1688.com/solution/solutionDetail.htm?solutionKey=1697014160788#apiAndMessageList
const getters = {
  skuFirstProp (state) {
    const firstProp = {
      attributeName: '',
      attrs: [],
    }
    if (state.goodsInfo && state.goodsInfo.productSkuInfos) {
      state.goodsInfo.productSkuInfos.forEach(item => {
        if (item.skuAttributes.length === 2) {
          firstProp.attributeName = item.skuAttributes[0].attributeName
          if (!firstProp.attrs.find(v => v.value === item.skuAttributes[0].value)) {
            firstProp.attrs.push({
              attributeId: item.skuAttributes[0].attributeId,
              skuImageUrl: item.skuAttributes[0].skuImageUrl,
              value: item.skuAttributes[0].value,
            })
          }
        }
      })
    }
    return firstProp
  },
  skuSecondProp (state) {
    const secondProp = {
      attributeName: '',
      attrs: [],
    }
    if (state.goodsInfo && state.goodsInfo.productSkuInfos) {
      state.goodsInfo.productSkuInfos.forEach(item => {
        let secondPropIndex = 0
        if (item.skuAttributes.length === 2) {
          secondPropIndex = 1
          if (state.firstPropsValue && item.skuAttributes[0].value !== state.firstPropsValue) {
            return
          }
        }
        secondProp.attributeName = item.skuAttributes[secondPropIndex].attributeName
        if (!secondProp.attrs.find(v => v.value === item.skuAttributes[secondPropIndex].value)) {
          secondProp.attrs.push({
            attributeId: item.skuAttributes[secondPropIndex].attributeId,
            skuImageUrl: item.skuAttributes[secondPropIndex].skuImageUrl,
            value: item.skuAttributes[secondPropIndex].value,

            skuInfo: item,
          })
        }
      })
    }
    return secondProp
  },
  buyText (state) {
    return Object.keys(state.buyNumMap).map(key => {
      if (state.goodsInfo && state.goodsInfo.productSkuInfos && state.buyNumMap[key] > 0) {
        const skuInfo = state.goodsInfo.productSkuInfos.find(v => String(v.specId) === key)
        return `${skuInfo.skuAttributes.map(attr => attr.value).join(' ')} x${state.buyNumMap[key]}`
      }
      return ''
    }).filter(s => s).join('\n')
  },
  buyNumMapStats (state) {
    if (!state.goodsInfo) {
      return {}
    }
    const qtyTotal = Object.values(state.buyNumMap).reduce((a, b) => a + Number(b || 0), 0)
    const priceRangeList = [...state.goodsInfo.productSaleInfo.priceRangeList]
    // startQuantity 从大到小排序
    priceRangeList.sort((a, b) => b.startQuantity - a.startQuantity)
    const priceRange = priceRangeList.find(item => item.startQuantity <= qtyTotal)

    const amount = Object.keys(state.buyNumMap).reduce((curr, key) => {
      if (state.goodsInfo && state.goodsInfo.productSkuInfos && state.buyNumMap[key] > 0) {
        const skuInfo = state.goodsInfo.productSkuInfos.find(v => String(v.specId) === key)
        let price = 0
        if (state.goodsInfo.productSaleInfo.quoteType === 1) {
          // https://detail.1688.com/offer/726988909993.html
          // consignPrice 为一件代发的价格
          price = calc.mul(skuInfo.price || skuInfo.consignPrice, state.buyNumMap[key])
        } else {
          price = calc.mul(priceRange ? priceRange.price : state.goodsInfo.productSaleInfo.priceRangeList[0].price, state.buyNumMap[key])
        }
        return calc.add(curr, price)
      }
      return curr
    }, 0)
    return {
      amount,
      qtyTotal,
      goodsTypeQty: Object.keys(state.buyNumMap).filter(key => state.buyNumMap[key] > 0).length,
    }
  },
  // nearAddrid (state) {
  //   let receiveAddrid = ''
  //   const sendGoodsAddressText = state.goodsInfo?.productShippingInfo?.sendGoodsAddressText
  //   if (!sendGoodsAddressText) return ''
  //   // 裏賣家最近的倉庫
  //   // 浙江省  对应 义乌仓
  //   // 上海市  对应 上海仓
  //   // 广东省  对应 东莞仓
  //   // 福建省  对应 福州前置仓（平潭）
  //   if (sendGoodsAddressText.indexOf('浙江省') > -1) {
  //     receiveAddrid = '1579'
  //   } else if (sendGoodsAddressText.indexOf('上海市') > -1) {
  //     receiveAddrid = '1210'
  //   } else if (sendGoodsAddressText.indexOf('广东省') > -1) {
  //     receiveAddrid = '2769'
  //   } else if (sendGoodsAddressText.indexOf('福建省') > -1) {
  //     receiveAddrid = '3591'
  //   }
  //   return receiveAddrid
  // },
  // 选择最小的数量报价
  goodsInfoMinNumberAmount (state) {
    if (state.flow === 'fenxiao') {
      return state.goodsInfo.productSkuInfos[0].consignPrice
    }
    // 商品有三个报价类型（saleInfo.quoteType）.
    // saleInfo.quoteType=0表示无SKU按数量报价;
    // saleInfo.quoteType=1有SKU按规格报价;
    // saleInfo.quoteType=2有SKU按数量报价;
    // 因此当等于0或者2时候，商品价格需要查看saleInfo.priceRanges的报价；而当等于1时候需要查看skuInfos.price的报价。
    // consignPrice 为一件代发的价格
    if (state.goodsInfo.productSaleInfo.quoteType === 1) {
      return Math.min(...state.goodsInfo.productSkuInfos.map(skuInfo => skuInfo.price || skuInfo.consignPrice))
    } else {
      return state.goodsInfo.productSaleInfo.priceRangeList[0].price
    }
  },
  minOrderQuantity (state) {
    return state.flow === 'fenxiao' ? 1 : state.goodsInfo.minOrderQuantity
  },
  batchNumber (state) {
    // 手數
    return state.flow === 'fenxiao' ? 1 : state.goodsInfo.batchNumber
  },
  erExchRateDisplay (state) { // 显示的汇率，不含1%的手续费
    if (state.prepareModel && state.prepareModel.exchrate) {
      return Number((state.prepareModel.exchrate.erExchRate * 0.99).toFixed(3))
    }
    return 0
  },
  catEmbargoInfo (state) {
    const tpCatalog = state.goodsInfo.tpCatalog
    let embargo = false
    let catShptBrief = ''
    if (tpCatalog) {
      catShptBrief = tpCatalog.catShptBrief
      // 海快、空運禁運
      if (String(tpCatalog.catEmbargoSe) === '1' && String(tpCatalog.catEmbargoAir) === '1') {
        embargo = true
      }
      const hasCcBan = String(tpCatalog.catCcMaxBox) === '0' || String(tpCatalog.catCcMaxQty) === '0' || String(tpCatalog.catCcMaxWt) === '0'
      // 進口限制
      if (hasCcBan) {
        embargo = true
      }
    }
    if (isVirtualGoods(state.goodsInfo.subject)) {
      embargo = true
      catShptBrief = '不支持代購虛擬物品'
    }

    return {
      embargo,
      catShptBrief,
    }
  },
}

const mutations = {
  setNearAddrid (state, nearAddrid) {
    state.nearAddrid = nearAddrid
  },
  setDetailOrder (state, detailOrder) {
    state.detailOrder = detailOrder
  },
  setPrepareModel (state, prepareModel) {
    state.prepareModel = prepareModel
    writeSS(SS_PREPARE_KEY, prepareModel)
  },
  setCategoryPathsModel (state, categoryPathsModel) {
    state.categoryPathsModel = categoryPathsModel
    writeSS(SS_CATEGORY_PATHS_KEY, categoryPathsModel)
  },
  setCouponrelList (state, couponrelList) {
    state.couponrelList = couponrelList
  },
  setFreight (state, freight) {
    state.freight = freight
  },
  setGoodsInfo (state, goodsInfo) {
    state.goodsInfo = goodsInfo ? converGoodsInfo(goodsInfo) : goodsInfo
  },
  setForm (state, form) {
    state.form = form
  },
  setBuyNumMap (state, buyNumMap) {
    state.buyNumMap = buyNumMap
  },
  setPreviewData (state, previewData) {
    state.previewData = previewData
  },
  setFirstPropsValue (state, firstPropsValue) {
    state.firstPropsValue = firstPropsValue
  },
  setStepId1688 (state, stepId1688) {
    state.stepId1688 = stepId1688
  },
  setOrderConfirmHtml (state, orderConfirmHtml) {
    state.orderConfirmHtml = orderConfirmHtml
  },
  initForm (state, form, rootState) {
    state.form = {
      dgType: 'DP', // DP: 直接付款, PA: 改價
      dgPymtMethod: 'BC',
      dgSource: '',
      bcid: '',
      dgMemo: '',
      dgMemoLanguage: 'zh',
      receiveAddrid: '',
      othderAddrid: '',
      addressParam: undefined,
      goods: {
        gsUrl: '',
        gsTitle: '',
      },
      agreeService: localStorage.getItem('dgorderAgreeService') === '1',
    }
    state.goodsInfo = null
    state.previewData = null
    state.freight = 0
    state.buyNumMap = {}
    state.flow = 'general'
    state.isDefaultInvoiceInfo = 0
  },

  setChoseDgids (state, choseDgids) {
    state.choseDgids = choseDgids
  },
  setFlow (state, flow) {
    state.flow = flow
  },
  setInvoiceInfo (state, invoiceInfo) {
    state.invoiceInfo = invoiceInfo
  },
  setIsDefaultInvoiceInfo (state, isDefaultInvoiceInfo) {
    state.isDefaultInvoiceInfo = isDefaultInvoiceInfo
  },
}

const actions = {
  prepare ({ state, commit, rootState }, params) {
    return rootState.axios.get('/magicbuy/dgorder/prepare', {
      params,
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  async ensurePrepare ({ state, commit, dispatch }) {
    if (state.prepareModel) return state.prepareModel
    const res = await dispatch('prepare')
    if (!res.data.error) {
      commit('setPrepareModel', res.data.model)
    }
    return state.prepareModel
  },
  async ensureCategoryPaths ({ state, commit, dispatch }) {
    if (state.categoryPathsModel) return state.categoryPathsModel
    const res = await dispatch('categoryPaths')
    if (!res.data.error) {
      commit('setCategoryPathsModel', res.data.model)
    }
    return state.categoryPathsModel
  },
  create ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/v1frontend/dgorder/create', params)
  },
  batchPayWithCouponSub ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/v1frontend/dgorder/batch-pay-with-coupon-sub', params)
  },
  batchPayWithCreditdg ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/v1frontend/dgorder/batch-pay-with-creditdg', params)
  },
  couponrelReceiveDgnewbie ({ state, commit, rootState }, params) {
    return rootState.axios.get('/magicbuy/v1frontend/dgorder/couponrel-receive-dgnewbie', { params })
  },
  search ({ state, commit, rootState }, params) {
    // return rootState.axios.get('/magicbuy/v1frontend/dgorder/search', { params })
    return rootState.axios.get('/magicbuy/dgorder/search', {
      params: {
        dgPlatform: '1688',
        ...params
      },
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  view ({ state, commit, rootState }, params) {
    // return rootState.axios.get('/magicbuy/v1frontend/dgorder/view', { params })
    return rootState.axios.get('/magicbuy/dgorder/view', {
      params,
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  cancel ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/v1frontend/dgorder/cancel', params)
  },
  payWithCreditdg ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/v1frontend/dgorder/pay-with-creditdg', params)
  },
  createPreorder ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/v1frontend/dgorder/create-preorder', params)
  },
  batchCreatePreorder ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/v1frontend/dgorder/batch-create-preorder', params)
  },
  viewDefaultInvoiceInfo ({ state, commit, rootState }, params) {
    return rootState.axios.get('/magicbuy/v1frontend/dgorder/view-default-invoice-info', { params })
  },
  updateExtrasInvoiceInfo ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/v1frontend/dgorder/update-extras-invoice-info', params)
  },
  batchUpdateExtrasInvoiceInfo ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/v1frontend/dgorder/batch-update-extras-invoice-info', params)
  },
  createPreview ({ state, commit, rootState }, { cargoParamList, cartOrder = true, ...params }) {
    if (!cargoParamList) {
      cargoParamList = Object.keys(state.buyNumMap).map(specId => {
        return {
          specId,
          quantity: state.buyNumMap[specId],
          offerId: state.goodsInfo.itemid
        }
      }).filter(item => item.quantity > 0)
    }

    return rootState.axios.post('/magicbuy/ali-dg/trade/order/create-preview', {
      ...params,
      cargoParamList,
      cartOrder,
      options: undefined,
    }, {
      baseURL: 'https://apisp.jyb.com.tw',
    }).then(res => {
      commit('setPreviewData', res.data.model)
      return res
    })
  },
  batchCreatePreview ({ rootState }, { cartOrder = true, ...params }) {
    return rootState.axios.post('/magicbuy/ali-dg/trade/order/batch-create-preview', {
      ...params,
      cartOrder,
    }, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  getPromoPrice ({ state, commit, dispatch, rootState }, params) {
    // https://detail.1688.com/offer/714357400339.html // PLUS价商品
    if (state.goodsInfo.promotionModel?.promotionType === 'plus') {
      state.goodsInfo.productSkuInfos.forEach(skuInfo => {
        if (skuInfo.promotionPrice > 0) {
          skuInfo.price = skuInfo.promotionPrice
        }
      })
      state.goodsInfo.productSaleInfo.priceRangeList.forEach(rangeItem => {
        if (rangeItem.promotionPrice > 0) {
          rangeItem.price = rangeItem.promotionPrice
          console.log(' rangeItem.promotionPrice', rangeItem.promotionPrice)
        }
      })
      state.goodsInfo.hasPromoPrice = true
    }
    // if (state.goodsInfo.productSaleInfo.quoteType === 1) {
    //   // state.goodsInfo.hasPromoPrice = true
    //   if (state.goodsInfo.productSkuInfos.length <= 10) {
    //     return Promise.all(state.goodsInfo.productSkuInfos.map(skuInfo => {
    //       return dispatch('createPreview', {
    //         receiveAddrid: '1591',
    //         flow: 'general',
    //         cargoParamList: [
    //           {
    //             specId: skuInfo.specId,
    //             quantity: state.goodsInfo.minOrderQuantity,
    //             offerId: state.goodsInfo.offerId,
    //           }
    //         ]
    //       }).then(res => {
    //         if (res) {
    //           skuInfo.price = calc.round(calc.div(res.data.model.preview[0].cargoList[0].amount, state.goodsInfo.minOrderQuantity), 2)
    //         }
    //       })
    //     })).then(() => {
    //       state.goodsInfo.hasPromoPrice = true
    //     })
    //   }
    // } else {
    //   return Promise.all(state.goodsInfo.productSaleInfo.priceRangeList.map(rangeItem => {
    //     if (state.goodsInfo.productSkuInfos[0].amountOnSale < rangeItem.startQuantity) {
    //       return true
    //     }
    //     return dispatch('createPreview', {
    //       receiveAddrid: '1591',
    //       flow: rangeItem.isOnePsale ? 'fenxiao' : 'general',
    //       cargoParamList: [
    //         {
    //           specId: state.goodsInfo.productSkuInfos[0].specId,
    //           quantity: rangeItem.startQuantity,
    //           offerId: state.goodsInfo.offerId,
    //         }
    //       ]
    //     }).then(res => {
    //       if (res) {
    //         rangeItem.price = calc.round(calc.div(res.data.model.preview[0].cargoList[0].amount, rangeItem.startQuantity), 2)
    //       }
    //     })
    //   })).then(() => {
    //     state.goodsInfo.hasPromoPrice = true
    //   })
    // }
  },
  productDetail ({ state, commit, rootState }, params) {
    return rootState.axios.get('/magicbuy/ali-dg/product/search/product-detail', {
      params,
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  categoryPaths ({ rootState }, params) {
    return rootState.axios.get('/magicbuy/os-dg/product/search/category-paths', {
      params,
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  productIndex ({ rootState }, params) {
    return rootState.axios.get('/magicbuy/os-dg/product/search/index', {
      params,
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  createOrder ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/ali-dg/trade/order/create-order', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  batchCreateOrder ({ state, commit, rootState }, { cartOrder = true, ...params }) {
    return rootState.axios.post('/magicbuy/ali-dg/trade/order/batch-create-order', {
      ...params,
      cartOrder,
    }, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  priceAdjust ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/ali-dg/order/notice/price-adjust', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  batchPriceAdjust ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/ali-dg/order/notice/batch-price-adjust', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  update ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/dgorder/update', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  batchUpdateDone ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/dgorder/batch-update-done', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  delete ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/dgorder/delete', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  searchAliOrder ({ state, commit, rootState }, params) {
    return rootState.axios.get('/magicbuy/ali-dg/search/search-ali-order', {
      params,
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  isExtendReceive ({ state, commit, rootState }, params) {
    return rootState.axios.get('/magicbuy/dgorder/is-extend-receive', {
      params,
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  extendConfirmTime ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/dgorder/extend-confirm-time', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  converGoodsInfo ({ state, commit }, goodsInfo) {
    return converGoodsInfo(goodsInfo)
  },
  searchByImage ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/tb-dg/product/search/image-query', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  cancelRefund ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/ali-dg/trade/refund/cancel', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
